import React from 'react';
import { stringifyError } from '@/utils/errors';
import { ConfigContainer } from '@/pages/Config/common/style/Common.style';
import { SavingBar } from '@/components/atoms/SavingBar';
import WebhookPanel from '@/pages/Config/Webhooks/WebhookPanel';
import BrandWebhookConfigurationPanel from '@/components/organisms/Webhook/BrandWebhookConfigurationPanel';
import { useCreateBrandWebhookVM } from './CreateBrandWebhook.viewmodel';

const CreateBrandWebhook: React.FunctionComponent<React.PropsWithChildren> = () => {
    const { isValid, setValid, formRef, isPostLoading, postError, webhookConfigDefaultData, onSave } =
        useCreateBrandWebhookVM();

    return (
        <>
            <ConfigContainer>
                <WebhookPanel isBrandLevel={true} />
                <BrandWebhookConfigurationPanel ref={formRef} webhook={webhookConfigDefaultData} setValid={setValid} />
            </ConfigContainer>
            <SavingBar
                onSave={onSave}
                displayChangesCount={false}
                loading={isPostLoading}
                disabled={!isValid}
                error={stringifyError(postError)}
            />
        </>
    );
};

export default CreateBrandWebhook;
